import React from "react";

import ArrowRightIcon from "images/icons/arrow-right-icon.inline.svg";

import Image from "../../components/image";
import { Link } from "../../utils/customLink";

const FloatingPromo = ({
  showFloating,
  handleClosePromo,
  promoImage,
  promoAmountTitle,
  promoSubtitle,
  promoCtaLink,
  promoCtaTitle,
  promoCmbLink,
  promoCmbTitle,
  type = "blog",
  floatingBg = "dark:bg-white bg-generic-bg dark:bg-opacity-20 bg-opacity-60"
}) => {
  return (
    <>
      {showFloating && (
        <div
          className={`flex sm:flex-row flex-col items-center justify-between border border-white  backdrop-blur-xl p-0 ${
            showFloating ? "opacity-100" : "opacity-0"
          } transition ease-linear ${floatingBg}`}
        >
          <div
            className="absolute bg-white rounded-full w-6 h-6 sm:left-4 right-4 top-4 close-icon before:left-[10px] before:top-[4px] after:left-[10px] after:top-[4px]"
            onClick={handleClosePromo}
          />
          <div className="promo-image sm:h-[10rem] h-[4.5rem] w-full">
            <Image
              imageAlt={""}
              image={""}
              imageClass="object-cover w-full h-full md:object-left"
              sourceUrl={promoImage}
            />
          </div>
          <div className="px-4 py-3 promo-content shrink-0">
            {type === "blog" ? (
              <h3
                className="font-semibold font-body"
                dangerouslySetInnerHTML={{ __html: promoAmountTitle }}
              />
            ) : (
              promoAmountTitle
            )}
            <p className="py-2 text-xs dark:text-white text-black-lighter">
              {promoSubtitle}
            </p>

            <div className="flex justify-between mt-3 gap-3">
              {promoCtaLink && (
                <div className="w-full apply-programs-link">
                  <Link
                    className="apply-program-link flex gap-2 items-center w-full justify-center h-10
              text-base text-white dark:text-sm font-semibold leading-7 tracking-wider dark:text-gray-darker  bg-red-light dark:bg-green-standard
              px-7 rounded-xxxxl dark:rounded-sm hover:bg-red-light "
                    to={promoCtaLink}
                  >
                    <span>{promoCtaTitle}</span>
                    <ArrowRightIcon className="stroke-white dark:stroke-gray-darker" />
                  </Link>
                </div>
              )}

              {promoCmbLink && (
                <Link
                  className="callback-button h-10 w-full flex justify-center items-center"
                  to={promoCmbLink}
                >
                  {promoCmbTitle}
                </Link>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FloatingPromo;
